export class Assegnazione {
    portale = '';
    id_diretta: number = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/assegnazione.ts